// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/boundaries/';
export const actions = [
  'SET_FIELD_BOUNDARIES_BY_FIELD_UUID'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer (
  state={},
  action={}
) {
  switch(action.type) {
    case actions.SET_FIELD_BOUNDARIES_BY_FIELD_UUID:
      return {
        ...state,
        [action.payload.fieldUuid]: action.payload.boundaries
      };

    default:
      return state;
  }
}

// Action Creators

export const setFieldBoundariesByFieldUuid = ({ boundaries, fieldUuid }) => {
  return {
    type: actions.SET_FIELD_BOUNDARIES_BY_FIELD_UUID,
    payload: { boundaries, fieldUuid }
  };
};
